module.exports = __webpack_public_path__ + "img/builder-33.d2b51d0a.webp";